import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { CartModel, LineItemModel, SkusModel, RequestLineItemModel, ResponseCartModel, ResponseLineItemModel } from './../../models';
import { UtilityService, HttpClientService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { throwError } from 'rxjs';

import { HttpResponse, HttpHeaders } from '@angular/common/http';
import { ANALYTICS_CONSTANTS } from 'config';
import { FormGroup } from '@angular/forms';

declare var ENV_PORTAL;
@Injectable()
export class CartService {
  form: any;
  errors: any;
  messages: any;
  formArrayName: string;
  dataLayer: {};

  constructor(private utilityService: UtilityService,
    private httpClientService: HttpClientService, private adobeAnalyticsService: AdobeAnalyticsService
  ) { }

  updateCartQty(cart: CartModel) {
    let fQty = 0;
    if (cart && cart != null && cart.lineItems && cart.lineItems.length > 0) {
      fQty = cart.lineItems.length;
    }
  }

  tokenRefresh() {
    this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
  }

  handleError = (error) => {
    return throwError(error);
  }

  checkProductAlreadyPresent(lineItems: Array<LineItemModel>, lineItem: LineItemModel): boolean {
    for (const item of lineItems) {
      if (item.productId === lineItem.productId) {
        return true;
      }
    }
    return false;
  }

  checkSkuAlreadyPresent(cartLineItems: Array<LineItemModel>, lineItem: LineItemModel): any {
    for (const item of cartLineItems) {
      if (item.productId === lineItem.productId && item.sku.id !== lineItem.sku.id) {
        return item.sku.displayName + '(' + item.sku.skuType + ')'; // sending display name for model content
      }
    }
    return false;
  }
  updateCartItemwithNewSku(lineItems: Array<LineItemModel>, lineItem: LineItemModel): Array<LineItemModel> {
    lineItems.forEach(function (item, i) {
      if (item.productId === lineItem.productId) {
        lineItems[i] = lineItem;
      }
    });
    return lineItems;
  }

  // For Service Call reference
  updateQuantityPrice(cart) {
    return this.httpClientService.authorizedPost(this.utilityService.getEnvConfig().cartServiceUrl, cart)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res;
      }
      )
      ,catchError( this.handleError ));
  }

  updateCartPrice(cart, responseCart): CartModel {
    if (cart && cart.lineItems) {
      let index = 0;
      for (const iterateCart of cart.lineItems) {
        const filteredResponseObject = responseCart.lineItems.filter((data, subindex) =>
          ((data.itemCode === iterateCart.skuId) && (data.productId === iterateCart.productId)));

        filteredResponseObject.forEach((responseQtylineItem) => {
          cart.lineItems[index].priceInfo.monthlyRecurringFee.amount = responseQtylineItem.priceInfo.totalAmount.monthlyRecurringFee;
          cart.lineItems[index].priceInfo.oneTimeFee = [];
          cart.lineItems[index].priceInfo.oneTimeFee = responseQtylineItem.priceInfo.oneTimeFee;
          // Each lineItem of Sku contains priceinfo object
          cart.lineItems[index].sku.priceInfo.monthlyRecurringFee.amount =
            responseQtylineItem.priceInfo.monthlyRecurringFee.unitPrice;
          cart.lineItems[index].sku.priceInfo.oneTimeFee = [];
          cart.lineItems[index].sku.priceInfo.oneTimeFee = responseQtylineItem.priceInfo.oneTimeFee;
          // this.cart.lineItems[sindex].priceInfo.oneTimeFee.amount = lineItem.priceInfo.totalAmount.oneTimeFee;
          cart.lineItems[index].productConfigurations = [];
        });
        if (filteredResponseObject && filteredResponseObject.length === 0) {
          cart.lineItems[index].priceInfo.monthlyRecurringFee.amount = 0;
        }
        index++;
      }
      delete cart.ban;
      delete cart.fan;
      delete cart.ctn;
      sessionStorage.removeItem('steps-checkout');
      sessionStorage.removeItem('cart-order');
      cart.isApplySame = false;
      cart.priceInfo.monthlyRecurringFee.amount = responseCart.cartSummary.totalAmount.totalMonthlyRecurringFee;
      cart.priceInfo.oneTimeFee.amount = responseCart.cartSummary.totalAmount.totalOneTimeFee;
    }
    return cart;
  }

  updateCartPricewithIndex(cart, responsecart, rowIndex): CartModel {
    responsecart.lineItems.forEach((responseCartLineItem) => {
      if ((responseCartLineItem.itemCode === cart.lineItems[rowIndex].skuId)
        && (responseCartLineItem.productId === cart.lineItems[rowIndex].productId)) {
        // Each Linetimes contains priceinfo object
        cart.lineItems[rowIndex].priceInfo.monthlyRecurringFee.amount =
          responseCartLineItem.priceInfo.totalAmount.monthlyRecurringFee;
        cart.lineItems[rowIndex].priceInfo.oneTimeFee = [];
        cart.lineItems[rowIndex].priceInfo.oneTimeFee = responseCartLineItem.priceInfo.oneTimeFee;
        // Each lineItem of Sku contains priceinfo object
        cart.lineItems[rowIndex].sku.priceInfo.monthlyRecurringFee.amount =
          responseCartLineItem.priceInfo.monthlyRecurringFee.unitPrice;
        cart.lineItems[rowIndex].sku.priceInfo.oneTimeFee = [];
        cart.lineItems[rowIndex].sku.priceInfo.oneTimeFee = responseCartLineItem.priceInfo.oneTimeFee;
        cart.lineItems[rowIndex].productConfigurations = [];
      }
    });
    cart.priceInfo.monthlyRecurringFee.amount = responsecart.cartSummary.totalAmount.totalMonthlyRecurringFee;
    cart.priceInfo.oneTimeFee.amount = responsecart.cartSummary.totalAmount.totalOneTimeFee;
    delete cart.ban;
    delete cart.fan;
    delete cart.ctn;
    sessionStorage.removeItem('steps-checkout');
    sessionStorage.removeItem('cart-order');
    cart.isApplySame = false;
    return cart;
  }

  createRequestCart(lineItem: LineItemModel): RequestLineItemModel {
    let requestLineItem = null;
    requestLineItem = new RequestLineItemModel();
    requestLineItem.itemCode = lineItem.skuId;
    requestLineItem.productId = lineItem.productId;
    requestLineItem.quantity = Number(lineItem.quantity);
    return requestLineItem;
  }

  getServiceProdDetails(requestDcmCode) {
    const requestObject = {
      'dcmCodes': requestDcmCode.dcmCodes,
      'configurationType': 'configurations',
    };
    return this.httpClientService.authorizedPost(this.utilityService.getEnvConfig().productSpecificationUrl, requestObject)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.tokenRefresh();
       this.httpClientService.updateAuthorizationHeaders(res);      
        return res.body;
      }
      )
      ,catchError( this.handleError ));
  }

  getServiceProdTnc(dcmCodes) {
    return this.httpClientService.authorizedPost(this.utilityService.getEnvConfig().productTncUrl, dcmCodes)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res;
      }
      )
      ,catchError( this.handleError ));
  }

  // Page Load
  createPageLoadProperties(cart: CartModel, url: string, title: string, friendlyPageName: string, pageSection) {
    this.dataLayer = {};
    this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = friendlyPageName;
    this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_CHECKOUT;
    this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
    let sku;
    if (cart) {
      for (const lineItem of cart.lineItems) {
        sku = (sku === undefined) ? lineItem.sku.socCode : sku + '|' + lineItem.sku.socCode;
      }
      if (cart.ban) {
        this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_BAN] = cart.ban; // BAN
      }
      if (cart.ctn) {
        this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_CTN] = cart.ctn; // CTN
      }
    }
    this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SKU] = sku;
    this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
    this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Sales';
    if (pageSection === 'Checkout') {
      this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_ABS_CHECKOUT_STEP] = title;
    }
    this.adobeAnalyticsService.tag('page', this.dataLayer, 'Page_Load', 'pageLoad');
  }

  // ProductSpecificInfo_Checkout
  createProductSpecificInfoCheckout(cart: CartModel, status: string, event: string, errorCode?: string, errorText?: string) {
    this.dataLayer = {};
    if (status === 'SUCCESS') {
      this.dataLayer[ANALYTICS_CONSTANTS.EVENT_ITEMS] = [];
      for (const lineItem of cart.lineItems) {
        const items = { 'itemSku': '' };
        items.itemSku = lineItem.sku.socCode;
        this.dataLayer[ANALYTICS_CONSTANTS.EVENT_ITEMS].push(items);
      }
      this.dataLayer[ANALYTICS_CONSTANTS.EVENT_SUCCESS_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_1;
      this.dataLayer[ANALYTICS_CONSTANTS.EVENT_ERROR_TYPE] = ANALYTICS_CONSTANTS.EVENT_ERROR_SUCCESS_TYPE;
      this.dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_CODE] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_0;
    } else {
      this.dataLayer[ANALYTICS_CONSTANTS.EVENT_SUCCESS_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_0;
      this.dataLayer[ANALYTICS_CONSTANTS.EVENT_ERROR_TYPE] = ANALYTICS_CONSTANTS.EVENT_ERROR_FAILURE_TYPE_FAILURE_SYSTEM;
      this.dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_CODE] = errorCode;
      // this.dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_MESSAGE] = errorText;
    }
    this.dataLayer[ANALYTICS_CONSTANTS.EVENT_EVENT_CODE] = ANALYTICS_CONSTANTS.EVENT_CODE_PRODUCTSPECIFICINFO_Checkout;
    this.adobeAnalyticsService.tag('event', this.dataLayer, ANALYTICS_CONSTANTS.EVENT_CODE_PRODUCTSPECIFICINFO_Checkout, event);
  }

  checkQty(val, limit) {
    return (group: FormGroup) => {
      const qty = group.controls[val];
      if (qty.value.length === 0) {
        return qty.setErrors({ 'required': true });
      } else {
        const qtyVal = Number(group.controls[val].value);
        if ((qtyVal !== null) && (qtyVal !== undefined) && (Number(qtyVal) === 0)) {
          return qty.setErrors({ 'pattern': true });
        } else if (qtyVal > limit) {
          return qty.setErrors({ 'limitErr': true });
        }
      }
    };
  }
}
